import { ExcelExportSheetConfig } from "../types";

/** Reserve (Activities & Dining) Excel export sheet definitions — add excelSheet entries here. */
export const reserveExcelExportSheets: ExcelExportSheetConfig[] = [];
